import { applyBeneficiaryUrls } from './link_urls'
import { createSearchResultsPanel, type SearchResultsPanel } from './search_results_panel'
import { type SearchPager } from './search_paging'
import { type SearchPage } from './search'

const WARN_PREFIX = '[progress-panel--searchable-select]'

export type LoaderElements = {
  panel: SearchResultsPanel
  pager: SearchPager
  query: () => string
  linkUrlBase: string | undefined
  loading: HTMLElement | undefined
  onResults?: () => void
}

export type Loader = {
  load(): Promise<void>
  loadMore(): Promise<void>
  cancel(): void
}

export const createLoader = (elements: LoaderElements): Loader => {
  const { panel, pager, loading } = elements

  const showMerged = (merged: SearchPage & { page: number }): void => {
    panel.showResults({ ...merged, items: applyBeneficiaryUrls(merged.items, elements.linkUrlBase) })
    elements.onResults?.()
  }

  async function load(): Promise<void> {
    panel.showLoading()

    const outcome = await pager.load(elements.query())

    if (outcome.status === 'error') {
      console.warn(WARN_PREFIX, outcome.error)
      panel.showError()

      return
    }

    if (outcome.status === 'ok') {
      showMerged(outcome.merged)

      return
    }

    panel.reset()
  }

  async function loadMore(): Promise<void> {
    if (!pager.nextPage() || pager.paging()) return

    loading?.classList.remove('hide')

    const outcome = await pager.loadMore(elements.query())

    if (outcome.status === 'error') console.warn(WARN_PREFIX, outcome.error)
    if (outcome.status === 'ok') showMerged(outcome.merged)

    loading?.classList.add('hide')
  }

  return { load, loadMore, cancel: pager.bump }
}
